import { HTMLAttributes } from "react";
import { cn } from "../../../utils/cn";
import styles from "./PChip.module.scss";

const VARIANT_OPACITY: Record<PChipVariant, number> = {
  primary: 0.1,
  alert: 0.3,
  loyalty: 0.15,
  success: 0.3,
  neutral: 0.2,
};

type PChipVariant = "primary" | "alert" | "loyalty" | "success" | "neutral";

export type PChipSize = "lg" | "md" | "sm" | "xs";

type PChipProps = HTMLAttributes<HTMLDivElement> & {
  variant?: PChipVariant;
  opacity?: number;
  size?: PChipSize;
  hasOutline?: boolean;
  /** Solid variant colour with knocked-out text, instead of the 10% wash. */
  filled?: boolean;
};

export const PChip = ({
  variant = "primary",
  opacity,
  size = "lg",
  hasOutline = false,
  filled = false,
  children,
  className,
  style,
  ...rest
}: PChipProps) => {
  const defaultOpacity = VARIANT_OPACITY[variant];

  return (
    <div
      {...rest}
      className={cn(
        styles.p_chip,
        styles[size],
        hasOutline && styles.has_outline,
        filled && styles.filled,
        styles[variant],
        className
      )}
      style={
        {
          // "--p-chip-color": color,
          "--p-chip-opacity": opacity ?? (filled ? 1 : defaultOpacity),
          ...style,
        } as React.CSSProperties
      }
    >
      <span style={{ position: "relative", zIndex: 1 }}>{children}</span>
    </div>
  );
};
